<template>
    <div>
      <b-card no-body>
      <b-tabs pills card>
      <b-tab title="Datos Generales" active>
        <b-row>
        
          <b-col md="12">
            
              <b-form-group label-for="v-paciente">
                <label>Paciente:</label>
                 <b-form-input v-model="searchQuery" placeholder="Search" @input="onInput"></b-form-input>
                  <b-list-group v-if="filteredItems.length">
                    <b-list-group-item v-for="item in filteredItems" :key="item.id" @click="selectItem(item)"
                      class="autocomplete-option d-block">
                      {{ item.text }}
                    </b-list-group-item>
                  </b-list-group>           
              </b-form-group>
            </b-col>
        </b-row>
        <b-row class="mt-1">
        <b-col md="6">
              <b-form-group label-for="v-derivacionseguro">
                <label>Derivado desde: </label>
                
                  <b-form-checkbox-group
                      
                      v-model="derivacionseguro"
                      :options="derivacionSeguros"
                      value-field="value"
                      text-field="text"
                      
                    ></b-form-checkbox-group>
                  
               
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="v-codderivacion">
                <label>Codigo de Derivacion:</label>
                
                  <b-form-input v-model="codderivacion" placeholder="Ingrese el codigo de la derivación" ></b-form-input>
                
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col md="6">
              <b-form-group label-for="v-fecderivacion">
                <label>Fecha de Derivacion:</label>
                <flat-pickr v-model="fecderivacion" class="form-control" :config="{ dateFormat: 'Y-m-d' }" />
                
              </b-form-group>
            </b-col>
          </b-row>

      </b-tab>
      <b-tab title="Laboratorio">
        
        <EditarDerivacionLaboratorio/>
      </b-tab>
      <b-tab title="Documentos">
        <EditMspsPaciente :paciente = "paciente" :pacientetext = "searchQuery" esLaboratorioDerivado = true :itemCit = "itemCit"/>
      </b-tab>
      
      
      
    </b-tabs>
    <b-col cols="12" class="d-flex justify-content-end align-text-bottom my-2">
    <b-button variant="primary" @click="actualizarCitaLaboratorioDerivacion">Editar informacion</b-button>
    </b-col>
      </b-card>  
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import rutas from '@/assets/utils/rutas.json';
  import flatPickr from 'vue-flatpickr-component';
  import { mapState } from 'vuex';
  import EditMspsPaciente from '../../../../shared/components/MspsPaciente/EditMspsPaciente.vue';
  import { fileService } from "@/shared/services";
  import Swal from 'sweetalert2'
import EditarDerivacionLaboratorio from '../../../citas/components/DerivacionLaboratorio/EditarDerivacionLaboratorio.vue';
import { estudioLabService } from "../../../laboratorio/services";
  
  export default {
    name: 'EditarLaboratorioDerivado',

    
  
    props: {
      dataLabDerivado: {
        type: Object,
        required: false
      },     
    },
    components: {
    EditMspsPaciente,
    
    EditarDerivacionLaboratorio,
    flatPickr,
    
  },
  
    data() {
      return {
        config: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
      },
        searchQuery:null,
        filteredItems : [],
        paciente : null,
        opsPaciente: [],
        derivacionSeguros:[ { text: 'IESS', value: '1' }, { text: 'ISSFA', value: '2' }, { text: 'ISSPOL', value: '3' }],
        derivacionseguro : '',
        codderivacion : null,
        fecderivacion : null,
        esimagenDerivada : true,
        itemCit: null,
        idCita: null
        
        
      }
    },
    methods : {

        async onRegisterExamenes() {
      console.log("entro a editar los laboratorios", this.stLaboratoriosList)
      
      let dataExamenesLS   = JSON.parse(localStorage.getItem("laboratorioitems")) || [];
         
      
      let responseExamenes = null

      if( this.stLaboratoriosList && this.stLaboratoriosList.length > 0 && this.stLaboratoriosList[0] && this.stLaboratoriosList[0].idEstLab){
          dataExamenesLS = this.stLaboratoriosList
          responseExamenes = await estudioLabService.update(dataExamenesLS);
      }else{
          dataExamenesLS   = [this.stLaboratoriosList]
          responseExamenes = await estudioLabService.update(dataExamenesLS);
      }
      
      
      
      
      console.log("entro a editar los laboratorios", responseExamenes)
      //this.processList.push({ text:"Examenes Registrados", value: responseExamenes });
      //localStorage.removeItem("laboratorioitems");
    },


      async actualizarCitaLaboratorioDerivacion() {
      try {
       


        let files = this.stDocsMsps
        
        const urlMspPaciente      = await fileService.upload('msp', files.mspPaciente, this.paciente);
        const urlMspTitular1      = await fileService.upload('msp', files.mspTitular1, this.paciente);
        const urlMspTitular2      = await fileService.upload('msp', files.mspTitular2, this.paciente);
        const urlMspTitular3      = await fileService.upload('msp', files.mspTitular3, this.paciente);
        const urlDerivacion       = await fileService.upload('derivacion', files.derivacion, this.paciente);
        const urlCodigoDerivacion = await fileService.upload('codigoDerivacion', files.codigoDerivacion, this.paciente);
        const urlSolLabDer        = await fileService.upload('solicitudLaboratorio', files.solicitudLaboratorio, this.paciente)
        
       
        const argCita = {
          id: this.idCita,
          paciente: this.paciente,
         
          cobSeleccionada : this.derivacionseguro,
          codderivacion: this.codderivacion,
          fecderivacion: this.fecderivacion,
                
          urlsMspPaciente  : urlMspPaciente || "",
          urlsMspTitular1  : urlMspTitular1 || "",
          urlsMspTitular2  : urlMspTitular2 || "",
          urlsMspTitular3  : urlMspTitular3 || "",
          urlDerivacion    : urlDerivacion  || "",
          urlCodigoDer     : urlCodigoDerivacion || "",
          urlSolLabDer     : urlSolLabDer || "",
          segderivacion    : this.derivacionseguro
        };
        


        const response = await axios.post(rutas.axios + 'api', {
          query: `
          mutation editarCitaLaboratorioDerivado($id: String!, 
          
          $codderivacion : String, 
          $fecderivacion : String, 
          $urlDerivacion : String,
          $urlCodigoDer : String,   
          $urlSolLabDer : String,
          $cobSeleccionada: String,
          $urlsMspTitular1: String,
          $urlsMspTitular2: String,
          $urlsMspTitular3: String, 
          $urlsMspPaciente: String, 
          $paciente: String, 
        
          $segderivacion : String
          ) {
                    editarCitaLaboratorioDerivado(id: $id, 
                    urlSolLabDer : $urlSolLabDer,
                    cobSeleccionada : $cobSeleccionada,
                    codderivacion: $codderivacion, 
                    fecderivacion : $fecderivacion, 
                     
                    urlDerivacion : $urlDerivacion, 
                    urlCodigoDer : $urlCodigoDer, 
                    
                    urlsMspTitular1:$urlsMspTitular1,
                    urlsMspTitular2:$urlsMspTitular2,
                    urlsMspTitular3:$urlsMspTitular3, 
                    urlsMspPaciente: $urlsMspPaciente, 
                    paciente: $paciente, 
                    
                    segderivacion : $segderivacion
                    ) {
                        status
                        message
                        cita {
                        id
                        paciente {
                            id
                        }
                        doctor {
                            id
                        }
                        urlsMspPaciente
                        urlsMspTitular1
                        urlsMspTitular3
                        urlsMspTitular2
                        fechaCita
                        horaCita
                        derivacion
                        fecderivacion
                        codderivacion
                        urlDerivacion

                        }
                    }
                }
                `,
          variables: argCita
        });
          if (response.status === 200) {
            if (response.data.data.editarCitaLaboratorioDerivado.status === 'success') {
              await this.onRegisterExamenes()

              Swal.close();

              await this.$swal({
                title: 'success',
                text: "Data actualizada exitosamente",
                icon: 'success',
              });
              this.$router.go()
            } else {
              this.$swal({
                title: 'Error',
                text: response.data.data.editarCitaLaboratorioDerivado.message,
                icon: 'error',
                confirmButtonColor: '#089599',
              })
            }
          }
        
      } catch (err) {
        console.log('Error en actualizar cita:', err)
        this.$swal({
          title: 'Error',
          text: 'Error en actualizar cita: ' + err,
          icon: 'error',
          confirmButtonColor: '#089599',
        })
      }
    },

      selectItem(item) {
      console.log("item seleccionado", item)
      this.paciente = item; // Save the entire selected item to paciente
      this.searchQuery = item.text; // Update the input/display value
      console.log(item.text);
      console.log(this.paciente);
      this.filteredItems = []; // Clear the dropdown options after selecting
    },
      onInput() {
      if (this.searchQuery.length >= 3) {
        this.fetchPacientes(this.searchQuery);
      } else {
        this.filteredItems = [];
      }
    },
    async fetchPacientes(nomb_pac) {
      const query = `
                query SearchPacientes($nombre: String) {
                  allPacientes(nombre: $nombre) {
                    total
                    status
                    message
                    paciente {
                      id
                      persona {
                        primerNombre
                        primerApellido
                        identificacion
                      }
                    }
                  }
                }
              `
      try {
        console.log("paciente: " + nomb_pac ? nomb_pac : this.paciente ? this.paciente : '');
        const response = await axios.post(rutas.axios + 'api', {
          query,
          variables: {
            nombre: nomb_pac ? nomb_pac: ''  // This is the search term from the user 
          }
        });
        console.log(response.data.data.allPacientes.paciente);
        this.opsPaciente = response.data.data.allPacientes.paciente.map(item => ({
          value: item.id,
          text: `${item.persona?.primerApellido} ${item.persona?.primerNombre} ${item.persona?.identificacion}`,
          identificacion: item.persona.identificacion
        }));
        this.filteredItems = this.opsPaciente;
      } catch (error) {
        console.error("Error fetching paciente: ", error.response.data);
      }
    },
    },
    computed: {
    ...mapState({
      stLaboratoriosList: state => state.atencionCita.laboratorios.laboratorioList,
      stDocsMsps: state => state.docsMsps?.files,
      
    }),
    },

    watch:
    {
      dataLabDerivado: {
      handler(newVal) {
        
          this.fecderivacion = newVal.fecderivacion
          this.codderivacion = newVal.codderivacion
          this.derivacionseguro = newVal.cobSeleccionada.id
          this.searchQuery = `${newVal.paciente} ${newVal.identificacionPaciente}`,
          this.paciente = newVal.idPaciente,
          this.itemCit = newVal.itemCit,
          this.idCita = newVal.idCita
        
      },
      immediate: true, //carga cuando el componente apenas se ha montado
      deep: true,
      

    }
    }
  
  }
  </script>
  